import { formatDate } from '@fukuri-admins/utils/common/date';
import clsx from 'clsx';
import React from 'react';
import { CompanyDepositTableData } from '../../../types/companyDeposit/CompanyDepositTableData';
import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType';
import { ActionTableSortParamsType } from '../../../types/table/ActionTableSortParamsType';
import { formatCurrency } from '../../../utils/formatCurrency';
import { TableRoot } from '../../common/Table/TableBase/TableRoot';
import styles from './styles.module.scss';

type CompanyDepositTableContentProps = {
  columns: ActionTableColumnsType[];
  rows: CompanyDepositTableData[];
  sortParams: ActionTableSortParamsType;
  headerSort: (column: string) => void;
};

export const CompanyDepositTableContent: React.FC<CompanyDepositTableContentProps> = ({
  columns,
  rows,
  sortParams,
  headerSort,
}) => {
  const columnContent = (row: CompanyDepositTableData, key: ActionTableColumnsType['key']) => {
    if (key === 'target_month') {
      return formatDate({ date: new Date(row.target_month), formatType: 'yyyy年M月' });
    }
    if (key === 'amount') {
      return formatCurrency(row.amount);
    }
    if (key === 'deposit_status') {
      return row.deposited_at ? '入金済み' : '未入金';
    }
    return null;
  };

  const tableRows = rows.map((row: CompanyDepositTableData, key: number) => (
    <tr key={key} className={clsx(styles.tableRow)} data-testid={`table-row-${key}`}>
      {columns.map((column, columnIndex) => (
        <td
          key={column.key}
          className={clsx(styles.tableCell, {
            [styles.clickable]: column.sortable,
          })}
          onClick={() => {
            if (column.sortable) {
              headerSort(column.key);
            }
          }}
          data-testid={`table-cell-${columnIndex === 0 ? 'no' : column.key}`}
        >
          {columnContent(row, column.key)}
        </td>
      ))}
    </tr>
  ));

  if (rows?.length === 0 || rows === null) {
    return <div className={styles.emptyTable}>データなし</div>;
  }

  return (
    <TableRoot
      columns={columns}
      rows={tableRows}
      sortParams={sortParams}
      onClickHeader={column => headerSort(column)}
    />
  );
};
